import { Outlet } from "react-router";
import { ProspectionTabs } from "@/components/admin/prospection/tabs";
import { useView } from "@shared/client/view";

type TabsData = { counts: { outbox: number; replies: number } };

/** Prospection sortante : base, envois, réponses, boîtes et réglages. */
export default function ProspectionLayout() {
  // Les compteurs ne doivent jamais empêcher l'écran de s'ouvrir.
  const { data } = useView<TabsData>("/api/views/admin/prospection/tabs");
  return (
    <>
      <ProspectionTabs counts={data?.counts ?? {}} />
      <Outlet />
    </>
  );
}
